import { encodeEscPosPlainText, type ThermalPrintDocument } from '@vuelto/print';
import { isAllowedPrintAgentUrl } from '../agentClient';

function bytesToBase64(bytes: Uint8Array): string {
  if (typeof Buffer !== 'undefined') {
    return Buffer.from(bytes).toString('base64');
  }
  let binary = '';
  for (let i = 0; i < bytes.length; i += 1) {
    binary += String.fromCharCode(bytes[i]!);
  }
  return btoa(binary);
}

export async function webAgentPrintTransport(args: {
  agentUrl: string;
  document: ThermalPrintDocument;
  printerName?: string;
}): Promise<void> {
  const base = args.agentUrl.replace(/\/$/, '');
  // #796: validar URL contra allowlist antes de enviar datos (localhost + LAN privada)
  if (!isAllowedPrintAgentUrl(base)) {
    throw new Error('URL del agente de impresión no permitida. Solo hosts locales o de red local.');
  }
  const url = `${base}/print`;
  const escpos = args.document.escpos ?? encodeEscPosPlainText(args.document.text);
  const escposBase64 = bytesToBase64(escpos);
  const res = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    // Un agente caído o una IP LAN apagada no puede colgar el checkout.
    signal: AbortSignal.timeout(8000),
    body: JSON.stringify({
      escposBase64,
      text: args.document.text,
      printerName: args.printerName || undefined,
    }),
  });
  if (!res.ok) {
    const body = await res.text().catch(() => '');
    throw new Error(
      body.trim()
        ? `Agente de impresión respondió ${res.status}: ${body.slice(0, 120)}`
        : `Agente de impresión respondió ${res.status}. ¿Está corriendo en ${args.agentUrl}?`,
    );
  }
}
